import type { RegionStat } from '../data/types'

type RegionOverviewProps = {
  regions: RegionStat[]
}

export function RegionOverview({ regions }: RegionOverviewProps) {
  const maxPending = Math.max(...regions.map((r) => r.pending))

  return (
    <section className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm sm:p-6">
      <div className="mb-4">
        <h2 className="text-base font-semibold text-slate-900">တိုင်းဒေသကြီး/ပြည်နယ်အလိုက် အနှစ်ချုပ်</h2>
        <p className="text-sm text-slate-500">တိုင်းဒေသကြီး/ပြည်နယ်အလိုက် စောင့်ဆိုင်းဆဲလျှောက်လွှာများ</p>
      </div>

      <ul className="space-y-4">
        {regions.map((region) => {
          const percentage = Math.round((region.pending / maxPending) * 100)

          return (
            <li key={region.region}>
              <div className="mb-1.5 flex items-center justify-between gap-2">
                <span className="text-sm font-medium text-slate-700">{region.region}</span>
                <span className="text-sm font-semibold text-blue-700">
                  {region.pending} တင်ပြထားသည်
                </span>
              </div>
              <div className="h-2 overflow-hidden rounded-full bg-slate-100">
                <div
                  className="h-full rounded-full bg-blue-600 transition-all"
                  style={{ width: `${percentage}%` }}
                  role="progressbar"
                  aria-valuenow={region.pending}
                  aria-valuemin={0}
                  aria-valuemax={maxPending}
                  aria-label={`${region.region}: စောင့်ဆိုင်းဆဲ လျှောက်လွှာ ${region.pending} ခု`}
                />
              </div>
              <p className="mt-1 text-xs text-slate-400">
                စုစုပေါင်းမှတ်တမ်း {region.total.toLocaleString()} ခု
              </p>
            </li>
          )
        })}
      </ul>
    </section>
  )
}